import { createSlice, PayloadAction } from '@reduxjs/toolkit'; 

// ---------------
 
interface GroupState {
  groupAccess: any,
  groupStatus: string; 
}

// ---------------

const initialState: GroupState = {
  groupAccess: null, 
  groupStatus: '', 
};

// ---------------


export const groupSlice = createSlice({

  name: 'group',

  initialState,

  reducers: {

    setGroupAccess: (state, action: PayloadAction<any>) => { 

        state.groupAccess = action.payload; 

    },
    setGroupStatus: (state, action: PayloadAction<any>) => { 

        state.groupStatus = action.payload; 

    }, 
    resetGroup: (state) => { 
        
      state.groupAccess = null; 
      state.groupStatus = ''; 

    } 

  },

}); 

// ---------------

export const { 
  setGroupAccess, 
  setGroupStatus, 
  resetGroup 
} = groupSlice.actions;

export default groupSlice.reducer;